<div class="heatmap">
  <h2 class="title">{{mapTitle}} <span class="title-date">{{currentDate | date : "longDate"}}</span></h2>
  <div class="jvectormap">
    <div id="{{mapId}}" class="container"></div>
  </div>
</div>
<!-- begin legend -->
<app-map-legend [heatMapColors]="legend"></app-map-legend>
<!-- end legend -->


// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/map-temperature-departure-from-normal/map-temperature-departure-from-normal.component.html